<av-content-container [fullHeight]="true">
    <div class="col-12">
        <div class="av-billing-page">
            <div class="av-billing-heading">
                <h1 class="mb-1">{{ 'app.billing.title' | translate }}</h1>
                <p class="av-billing-note m-0">{{ 'app.billing.subtitle' | translate }}</p>
            </div>

            @if (facade.isSuspended()) {
            <div class="av-billing-banner">
                <span>{{ 'app.billing.state.suspended' | translate }}</span>
            </div>
            }

            @if (facade.isPastDue()) {
            <div class="av-billing-banner">
                <div class="d-flex align-items-center gap-2">
                    <mat-icon>error_outline</mat-icon>
                    <span class="fw-semibold">{{ 'app.billing.past_due.title' | translate }}</span>
                </div>
                <span>{{ 'app.billing.past_due.body' | translate }}</span>
                @if (facade.lastFailedPayment(); as failed) {
                <span>{{ 'app.billing.past_due.reason' | translate: { reason: failed.failure_message ?? failed.failure_code } }}</span>
                }
                @if (!facade.isReadOnly()) {
                <div class="av-billing-box__actions">
                    <button mat-flat-button color="primary" (click)="retryPayment()">
                        {{ 'app.billing.actions.retry_payment' | translate }}
                    </button>
                </div>
                }
            </div>
            }

            <div class="row g-4">
                <div class="col-12 col-lg-8">
                    <div class="av-billing-main">
                        <app-billing-invoices-card [invoices]="facade.invoices()" [count]="facade.invoiceCount()"
                            [pageIndex]="facade.invoicePageIndex()" [pageSize]="facade.invoicePageSize()"
                            [isReadOnly]="facade.isReadOnly()" [isLoading]="facade.isInvoicesLoading()"
                            (pageChange)="onInvoicePage($event)"
                            (reload)="facade.reloadInvoices()"></app-billing-invoices-card>

                        @if (facade.subscription()) {
                        <app-billing-payment-method-card [paymentMethod]="facade.paymentMethod()"
                            [billingContact]="facade.billingContact()" [isReadOnly]="facade.isReadOnly()"
                            [isLoading]="facade.isLoading()" (changeCard)="updateCard()"
                            (changeContact)="changeContact()"></app-billing-payment-method-card>
                        }
                    </div>
                </div>

                <div class="col-12 col-lg-4">
                    <div class="av-billing-sidebar">
                        <app-billing-subscription-card [subscription]="facade.subscription()" [plan]="facade.plan()"
                            [commitment]="facade.commitment()" [isReadOnly]="facade.isReadOnly()"
                            [isLoading]="facade.isLoading()" (changePlan)="openPlanPicker()"
                            (cancel)="cancelSubscription()" (resume)="resumeSubscription()"></app-billing-subscription-card>

                        @if (facade.subscription()) {
                        <app-billing-estimate-card [estimate]="facade.estimate()"
                            [isLoading]="facade.isEstimateLoading()" [hasError]="!!facade.estimateError()"
                            (retry)="retryEstimate()"></app-billing-estimate-card>
                        }
                    </div>
                </div>
            </div>
        </div>
    </div>
</av-content-container>
